exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "booking-limit-component span{color:#000!important;font-size:12px!important;display:block;width:100%}booking-limit-component span.danger{color:#fd0303!important}booking-limit-component span.success{color:#8cc152!important}.layout{display:flex}.layout .new-booking-panel{flex-shrink:0;width:400px;position:fixed;z-index:100;height:calc(100% - 70px);overflow:auto;background-color:#f9f9f9}@media (max-width:767px){.layout .new-booking-panel{width:0}}.layout .booking-list-panel{flex-grow:1;padding-left:415px;position:absolute;right:0;left:0;bottom:0;top:70px}@media (max-width:767px){.layout .booking-list-panel{padding-left:15px;padding-right:15px}}agreements form{padding-top:20px;padding-bottom:20px}agreements form a,agreements form a:link,agreements form a:visited{color:#fa5a00;font-weight:700}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/booking/agreements/agreements.styl
 ** module id = 327
 ** module chunks = 0
 **/